module.exports = __webpack_public_path__ + "static/2front-graphic-design-2-edc46040dbbf2be90123472a1451c1ad.png";